import { update } from "@intercom/messenger-js-sdk";

const hiddenLauncherRequests = new Set<symbol>();

export const isIntercomLauncherHidden = () => hiddenLauncherRequests.size > 0;

const updateLauncherVisibility = () => {
  if (window.Intercom) {
    update({ hide_default_launcher: isIntercomLauncherHidden() });
  }
};

export const hideIntercomLauncher = () => {
  const request = Symbol();
  hiddenLauncherRequests.add(request);
  updateLauncherVisibility();

  return () => {
    hiddenLauncherRequests.delete(request);
    updateLauncherVisibility();
  };
};
